/**
 * Determine the selected category name given a quote request form
 * element.
 */
function getSelectedCategoryName(formElement) {
	let categoryName = '';

	let categoryElement = formElement.querySelector('[name="category_id"]');

	if (!categoryElement) {
		return categoryName;
	}

	// We might have a category chosen via select menu or a radio
	// button (when dealing with a contact list).
	if (categoryElement.matches('select')) {
		// We need the selected option element.
		categoryName = categoryElement.options[categoryElement.selectedIndex].textContent;
		console.log('Category name via select element:', categoryName);
	} else if (categoryElement.matches('input[type="radio"]')) {
		// In this case we need the checked radio element.
		categoryElement = formElement.querySelector('[name="category_id"]:checked');
		if (categoryElement) {
			categoryName = categoryElement.parentNode.textContent;
			console.log('Category name via radio element:', categoryName);
		}
	} else if (categoryElement.matches('input[type="hidden"]')) {
		// In this case we should have another hidden input element
		// that contains the category name.
		categoryElement = formElement.querySelector('input[name="category_name"]');
		if (categoryElement) {
			categoryName = categoryElement.value;
			console.log('Category name via hidden element:', categoryName);
		}
	}

	return categoryName.trim();
}

export {
	getSelectedCategoryName
}